import {
  getSchema as getSchema1,
  getValidate as getValidate1,
  uiSchema as uiSchema1,
} from "./schema.requestInsurance.1";
import { IExtraData } from "./schema.requestInsurance.types";
import { getInitialValues } from "./schema.requestInsurance.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
      validate: getValidate1(extraData),
    },
  ];
};
